import React, { useMemo } from 'react'
import moment from 'moment'
import injectStyles from 'react-jss'
import { StatusLabel } from '../../../../../Components/StatusLabel'
import {
  dropTimeZoneFromDate,
  browserSafeNewDate,
} from '../../../../../shared/libraries/utils/date'
import { DATE_FORMAT } from '../../../../../constants'
import { getMetricResultsFromConversions } from '../../../../../Utils/Mission'
import { dateSort, timeOfDaySort, statusSort } from '../../../../../Utils/Table'
import SimpleTableTable from '../../../../../Components/SimpleTableTable'
import { StarRating } from '../../../../../Components/StarRating'

const styles = {
  wrapper: {
    '& .SearchAndFilters': {
      paddingLeft: '40px',
    },
    '& table': {
      marginLeft: '-25px',
    },
    '& .Pagination': {
      marginLeft: '40px',
    },
  },
}

const ambassadorActivityMapper = ambassadorActivity => {
  const {
    id,
    client,
    location,
    timeStart,
    rating,
    timeOfDay,
    cityPlan,
    isSpied,
  } = ambassadorActivity

  const localDate = browserSafeNewDate(dropTimeZoneFromDate(timeStart))
  const metrics = getMetricResultsFromConversions(
    ambassadorActivity.conversions,
  )
  return {
    id,
    isSpied,
    'CLIENT': client.name,
    'DATE': moment(localDate).format(DATE_FORMAT),
    'WEEK': moment(localDate).format('WW'),
    'TIME': timeOfDay,
    'RATING': rating,
    'CITY': cityPlan.city.name,
    'LOCATION': location ? location.name : '-',
    'METRIC I': metrics.primaryMetric,
    'METRIC II': metrics.secondaryMetric,
    'STATUS': ambassadorActivity.status,
    'FLYERS DISTR.': ambassadorActivity.checkout
      ? ambassadorActivity.checkout.flyerQuantity
      : '',
  }
}

const ambassadorActivitySorter = (a, b) =>
  new Date(b.timeStart).getTime() - new Date(a.timeStart).getTime()

const getActivityTableData = ambassadorActivities =>
  Array.from(ambassadorActivities)
    .sort(ambassadorActivitySorter)
    .map(ambassadorActivityMapper)

const ActivityTable = ({ ambassadorActivities, deleteMissions, ...props }) => {
  const header = [
    'CLIENT',
    'DATE',
    'WEEK',
    'TIME',
    'RATING',
    'CITY',
    'LOCATION',
    'FLYERS DISTR.',
    'METRIC I',
    'METRIC II',
    'STATUS',
  ]

  const sortOn = [
    'CLIENT',
    'WEEK',
    'RATING',
    'LOCATION',
    'NAME',
    'FLYERS DISTR.',
    'METRIC I',
    'METRIC II',
    { label: 'TIME', sort: timeOfDaySort },
    { label: 'DATE', sort: dateSort },
    { label: 'STATUS', sort: statusSort },
  ]

  const filterOn = [{ label: 'STATUS', sort: statusSort }]

  const data = useMemo(() => getActivityTableData(ambassadorActivities), [
    ambassadorActivities,
  ])

  const postRowRender = ambassadorActivity => {
    return {
      ...ambassadorActivity,
      'RATING': (
        <div onClick={e => e.stopPropagation()}>
          <StarRating
            className="stars"
            id={ambassadorActivity.id}
            score={parseFloat(ambassadorActivity.RATING, 10) || 0}
            uniqueId={ambassadorActivity.id}
          />
        </div>
      ),
      'STATUS': (
        <StatusLabel
          isSpied={ambassadorActivity.isSpied}
          status={ambassadorActivity.STATUS}
        >
          {ambassadorActivity.STATUS}
        </StatusLabel>
      ),
    }
  }

  const action = ambassadorActivity =>
    props.history.push(`/dashboard/mission/${ambassadorActivity.id}`)

  return (
    <div className={props.classes.wrapper}>
      <SimpleTableTable
        header={header}
        data={data}
        sortOn={sortOn}
        filterOn={filterOn}
        postRowRender={postRowRender}
        action={action}
        showPages={false}
      />
    </div>
  )
}

export default injectStyles(styles)(ActivityTable)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/ActivityTable/ActivityTable.js